// extracted by mini-css-extract-plugin
export default {"banner":"HomeBanner_banner__Y2g3W"};